import React from 'react';
import OTA_LOGO_MAP from '../../../../shared/types/ota-logo/OtaLogoTypes';
import './OtaOrLogo.css'; // Jangan lupa impor file CSS Anda

interface OtaOrLogoProps {
    otaName: string;
    source: string;
    logoUrl?: string;
    propertyName?: string;
}

const OtaOrLogo_Opsi1: React.FC<OtaOrLogoProps> = ({ otaName, source, logoUrl, propertyName }) => {
    const normalizedOta = otaName?.replace(/\s+/g, '');
    const otaLogo = OTA_LOGO_MAP[normalizedOta];

    return (
        <div className="logo-badge-container">
            {source !== 'direct' && otaLogo ? (
                // Tampilan untuk OTA
                <img
                    className="logo-image"
                    src={otaLogo}
                    alt={otaName}
                />
            ) : (
                // Tampilan untuk Direct Booking / Properti
                <>
                    {logoUrl && (
                        <img
                            className="logo-image"
                            src={logoUrl}
                            alt={propertyName}
                        />
                    )}
                    <div className="property-name">{propertyName}</div>
                </>
            )}
        </div>
    );
};

export default OtaOrLogo_Opsi1;